module.exports = __webpack_public_path__ + "img/per-minute.2deac02f.svg";